import React, { useState, useEffect } from "react";
import Card from "../card";
import Range from "../../../../components/common/FormFields/range";
import Select from "../../../../components/common/FormFields/select";
import "./index.scss";
import { useForm } from "react-hook-form";
import { getProductAttributes } from "../../../../service/productVariant/filterService";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Checkbox from "../../../../components/common/FormFields/checkbox";
import { getParamsFromURL } from "../../../../utils/helper";
import Input from "../../../../components/common/FormFields/input";
import Accordion from "react-bootstrap/Accordion";
import CustomSelect from "../../../../components/common/FormFields/select";
import { setAttributesFormForm } from "../../../../store/slices/product/productSlice";
import store from "../../../../store";
import ProductModal from "../../../attribute/component/modal";
import { useRef } from "react";
import { attribute } from "../../../../utils/router/constant";
import { getAllProductVariants } from "../../../../service/productVariant/productVariant";
import { getChildAttributeValue } from "../../../../service/order/orderService";
import { getDependentAttributeValues } from "../../../../service/productVariant/filterService";
import DateField from "../../../../components/common/FormFields/date";

const Filter1 = () => {
  const {
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const location = useLocation();
  const [entityid, setEntityid] = useState(null);
  const productAttributes = useSelector(
    (state) => state.product.productAttributes.child_product_list,
  );
  const attributeForm = useSelector(
    (state) => state.product.attributeForm.formState,
  );
  const [editingAttribute, setEditingAttribute] = useState(null);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const selectRef = useRef(null);
  const [sortField, setSortField] = useState("");
  const [sortType, setSortType] = useState("");
  const currentPage = useSelector((state) => state.insurance.currentPage);
  const pageSize = useSelector((state) => state.insurance.pageSize);

  const handleEditClick = (entityid, key) => {
    setEditingAttribute(`${entityid}-${key}`);

    setTimeout(() => {
      if (selectRef.current) {
        selectRef.current.focus();
      }
    }, 100);
  };

  // const handleChange = (entityid, attributeKey, value) => {
  //   const currentState = store.getState().product.attributeForm.formState;

  //   const updatedState = {
  //     ...currentState,
  //     [entityid]: {
  //       ...currentState[entityid],

  //       ...currentState[entityid],
  //       [attributeKey]: value,
  //     },
  //   };
  //   setValue(attributeKey, value);
  //   // const currentTabIndex = productTabs.findIndex(
  //   //   (tab) => tab.entityid === entityid
  //   // );

  //   // for (let i = currentTabIndex + 1; i < productTabs.length; i++) {
  //   //   const nextTab = productTabs[i];
  //   //   const hasAttribute = nextTab.attributes.some(
  //   //     (attr) => attr.attribute_key === attributeKey
  //   //   );

  //   //   if (hasAttribute) {
  //   //     updatedState = {
  //   //       ...updatedState,
  //   //       [nextTab.entityid]: {
  //   //         ...updatedState[nextTab.entityid],
  //   //         [attributeKey]: value,
  //   //       },
  //   //     };
  //   //   }
  //   // }
  //   store.dispatch(setAttributesFormForm(updatedState));
  //   console.log(updatedState);
  //   // getAllProductVariants(
  //   //   entityid,
  //   //   updatedState,
  //   //   sortField,
  //   //   sortType,
  //   //   currentPage,
  //   //   pageSize
  //   // );
  //   setEditingAttribute(null);
  // };

  const productTabs = productAttributes?.map((child) => ({
    name: child.name,
    entityid: child.entityid,
    attributes: child.product_attributes_list?.map((attribute) => ({
      label: attribute.name,
      lov: attribute.product_attribute_lov || [],
      element_type: attribute.element_type,
      attribute_key: attribute.attribute_key,
      show_in_filter: attribute.show_in_filter,
      is_primary: attribute.is_primary,
      is_disabled: attribute.is_disabled,
      min: attribute.filter_min,
      max: attribute.filter_max,
      maxLength: attribute.max_length,
      default_values: attribute.default_values,
      parent_key: attribute.parent_key || null,
      parent_attribute_key: attribute.parent_attribute_key || null,
      attribute_id: attribute.entityid || null,
      entityid: attribute.entityid,
      description: attribute.description,
      isRequired: attribute.required,
    })),
    addons: child.product_addon_list?.map((addon) => ({
      label: addon.label,
      name: addon.name || "",
      element_type: addon.element_type,
      lov: addon.product_addon_lov || [],
      min: addon.min_value,
      max: addon.max_value,
      isDisabled: addon.is_disabled,
      maxLength: addon.max_length,
      parent_key: addon.parent_key || null,
      entityid: addon.entityid,
      default_value: addon.default_value,
      isRequired: addon.isRequired,
    })),
  }));

  const handleArrayChange = (entityid, attributeKey, index, subKey, value) => {
    const currentState = store.getState().product.attributeForm.formState;
    const entityState = { ...currentState[entityid] };
    const arrayData = [...(entityState[attributeKey] || [])];

    arrayData[index] = {
      ...arrayData[index],
      [subKey]: value,
    };

    const updatedState = {
      ...currentState,
      [entityid]: {
        ...entityState,
        [attributeKey]: arrayData,
      },
    };
    store.dispatch(setAttributesFormForm(updatedState));
  };

  const handleDependentValue = (entityid, key, value) => {
    if (key === "qualification") {
      getDependentAttributeValues(entityid, key, value).then((response) => {
        if (response) {
          handleChange(
            entityid,
            "doctor_category",
            response.default_values
          );
          return;
        }
      });
    } else if (key === "pincode") {
      getDependentAttributeValues(entityid, key, value).then((response) => {
        if (response) {
          handleChange(
            entityid,
            "eq_zone",
            response.default_values,
          );
          return;
        }
      });
    } else {
      const processedValue = value === true ? "true" : value;

      productTabs?.forEach((tab) => {
        tab.attributes?.forEach((attr) => {
          if (
            attr.parent_attribute_key === key ||
            attr.parent_key === key
          ) {
            getChildAttributeValue(attr.entityid, processedValue).then((res) => {
              if (res) {
                const dependentValue =
                  res.attribute_value !== undefined
                    ? res.attribute_value
                    : res;

                if (dependentValue) {
                  handleChange(
                    tab.entityid,
                    attr.attribute_key,
                    dependentValue
                  );
                }
              }
            });
          }
        });
      });
    }
  };

  const handleChange = (entityid, attributeKey, value, showValue = null) => {
    const currentState = store.getState().product.attributeForm.formState;
    let updatedEntity = {
      ...currentState[entityid],
    };

    updatedEntity[attributeKey] = value;

    // Handle initialization/resizing for additional_variants
    const tab = productTabs?.find((t) => t.entityid === entityid);
    const variantField = 
      tab?.attributes?.find((a) => a.element_type === "additional_variants" && a.parent_key === attributeKey) ||
      tab?.addons?.find((a) => a.element_type === "additional_variants" && a.parent_key === attributeKey);

    if (variantField) {
      const count = parseInt(value) || 0;
      const vKey = variantField.attribute_key || variantField.name;
      const currentArray = updatedEntity[vKey] || [];

      if (count === 0) {
        delete updatedEntity[vKey];
      } else {
        const newArray = Array.from(
          { length: count },
          (_, i) => currentArray[i] || {},
        );
        updatedEntity[vKey] = newArray;
      }
    }

    // Clear dependent items
    const allItems = [...(tab?.attributes || []), ...(tab?.addons || [])];
    allItems.forEach((item) => {
      const fieldKey = item.attribute_key || item.name;
      if (item.parent_key === attributeKey) {
        const parentValueNum = parseInt(value) || 0;
        const shouldShow =
          (attributeKey === "ownership" && value !== "Rented") ||
          !attributeKey ||
          String(value).toLowerCase() === "yes" ||
          parentValueNum > 0;

        if (!shouldShow && updatedEntity[fieldKey]) {
          delete updatedEntity[fieldKey];
          setValue(fieldKey, "");
        }
      }
    });

    let updatedState = {
      ...currentState,
      [entityid]: updatedEntity,
    };

    setValue(attributeKey, showValue ? showValue : value);
    handleDependentValue(entityid, attributeKey, value);

    const currentTabIndex = productTabs?.findIndex(
      (tab) => tab.entityid === entityid,
    );

    if (currentTabIndex !== -1) {
       for (let i = currentTabIndex + 1; i < productTabs.length; i++) {
        const nextTab = productTabs[i];
        const hasAttribute = nextTab.attributes.some(
          (attr) => attr.attribute_key === attributeKey,
        );

        if (hasAttribute) {
          updatedState = {
            ...updatedState,
            [nextTab.entityid]: {
              ...updatedState[nextTab.entityid],
              [attributeKey]: value,
            },
          };
        }
      }
    }
   
    store.dispatch(setAttributesFormForm(updatedState));
    console.log(updatedState);
    setEditingAttribute(null);
  };

  return (
    <>
      <Card>
        <div className="filter--container">
          <div className="info-container">
            <div className="filter--header">
              <div className="widget--title">Your Information</div>
              <h4 className="filter--button" onClick={handleShow}>
                Edit
              </h4>
            </div>
            <div className="filter--accordion">
              {productTabs?.map((tab, index) => (
                <div key={index} className="tab-section">
                  {tab?.attributes
                    ?.filter((attr) => attr.is_primary === 1)
                    .map((attr, i) => {
                      const storedRawValue =
                        attributeForm[tab.entityid]?.[attr.attribute_key] ||
                        attr.default_values;

                      const storedValue =
                        attr.lov?.find(
                          (option) => option.attribute_value === storedRawValue,
                        )?.name || storedRawValue;

                      // return (
                      //   <div
                      //     key={i}
                      //     className={`form-group ${
                      //       storedValue &&
                      //       editingAttribute !==
                      //         `${tab.entityid}-${attr.attribute_key}`
                      //         ? "flex-container"
                      //         : ""
                      //     }`}
                      //   >
                      //     <label>{attr.label}</label>
                      //     {storedValue &&
                      //     editingAttribute !==
                      //       `${tab.entityid}-${attr.attribute_key}` ? (
                      //       <div
                      //         className="stored-value"
                      //         onClick={() =>
                      //           !attr.is_primary &&
                      //           handleEditClick(tab.entityid, attr.attribute_key)
                      //         }
                      //       >
                      //         {storedValue}
                      //       </div>
                      //     ) : attr.element_type === "dropdown" ||
                      //       attr.element_type === "range" ? (
                      //       <CustomSelect
                      //         key={attr.attribute_key}
                      //         name={attr.attribute_key}
                      //         control={control}
                      //         options={attr.lov.map((option) => ({
                      //           value: option.attribute_value,
                      //           label: option.name,
                      //         }))}
                      //         errors={errors}
                      //         defaultValue={storedValue}
                      //         onChange={(selectedOption) => {
                      //           handleChange(
                      //             tab.entityid,
                      //             // "product_attribute_list",
                      //             attr.attribute_key,
                      //             selectedOption?.value
                      //           );
                      //         }}
                      //       />
                      //     ) : attr.element_type === "number" ? (
                      //       <Input
                      //         key={attr.attribute_key}
                      //         type="number"
                      //         name={attr.attribute_key}
                      //         control={control}
                      //         placeholder={`Enter ${attr.label}`}
                      //         errors={errors}
                      //         rules={{
                      //           required: "This field is required",
                      //           min: {
                      //             value: attr.min || 0,
                      //             message: `Value must be at least ${
                      //               attr.min || 0
                      //             }`,
                      //           },
                      //           max: {
                      //             value: attr.max || 100,
                      //             message: `Value must be no more than ${
                      //               attr.max || 100
                      //             }`,
                      //           },
                      //         }}
                      //         defaultValue={storedValue}
                      //         onBlur={(e) => {
                      //           const value = e.target.value;
                      //           handleChange(
                      //             tab.entityid,
                      //             attr.attribute_key,
                      //             value
                      //           );
                      //         }}
                      //         autoFocus
                      //       />
                      //     ) : attr.element_type === "badge" ? (
                      //       <Input
                      //         key={attr.attribute_key}
                      //         type="text"
                      //         name={attr.attribute_key}
                      //         control={control}
                      //         placeholder={`Enter ${attr.label}`}
                      //         errors={errors}
                      //         rules={{
                      //           required: "This field is required",
                      //           min: {
                      //             value: attr.min || 0,
                      //             message: `Value must be at least ${
                      //               attr.min || 0
                      //             }`,
                      //           },
                      //           max: {
                      //             value: attr.max || 100,
                      //             message: `Value must be no more than ${
                      //               attr.max || 100
                      //             }`,
                      //           },
                      //         }}
                      //         value={getValues(attr.attribute_key) || ""}
                      //         onChange={(e) => {
                      //           const value = e.target.value;
                      //           handleChange(
                      //             attr.entityid,
                      //             // "product_attribute_list",
                      //             attr.attribute_key,
                      //             value
                      //           );
                      //         }}
                      //       />
                      //     ) : null}
                      //   </div>
                      // );
                      return (
                        <div key={i} className="form-group flex-container">
                          <label>{attr.label}</label>
                          <div className="stored-value">
                            {storedValue || "-"}
                          </div>
                        </div>
                      );
                    })}
                </div>
              ))}
            </div>
          </div>
          {productTabs?.some((tab) =>
            tab?.attributes?.some((attr) => attr.show_in_filter === 1)
          ) && (
            <div className="product-info-container">
              <div className="filter--accordion--header">
                <div className="widget--title">Revise Product</div>
              </div>
              <div className="divider"></div>
              <div className="filter--accordion">
                <Accordion defaultActiveKey="0">
                  {productTabs
                    ?.filter((tab) =>
                      tab?.attributes?.some((attr) => attr.show_in_filter === 1)
                    )
                    .map((tab, index) => (
                  <Accordion.Item key={index} eventKey={index.toString()}>
                    <Accordion.Header>{tab.name}</Accordion.Header>
                    <Accordion.Body>
                      {tab?.attributes
                        ?.filter((attr) => attr.show_in_filter === 1)
                        .map((attr, i) => {
                          const storedRawValue =
                            attributeForm[tab.entityid]?.[attr.attribute_key] ||
                            attr.default_values;

                          const storedValue =
                            attr.lov?.find(
                              (option) =>
                                option.attribute_value === storedRawValue,
                            )?.name || storedRawValue;

                          const isOwnershipRented =
                            attributeForm[tab.entityid]?.["ownership"] ===
                            "Rented";

                          if (
                            isOwnershipRented &&
                            attr.attribute_key === "building_cover"
                          ) {
                            return null;
                          }

                          if (attr.element_type === "additional_variants") {
                            const parentValueNum = parseInt(attributeForm[tab.entityid]?.[attr.parent_key]) || 0;
                            const count = parentValueNum;
                            const arrayData =
                              attributeForm[tab.entityid]?.[attr.attribute_key] || [];

                            const subFields = tab.attributes.filter(
                              (a) =>
                                a.element_type !== "additional_variants" &&
                                a.attribute_key !== attr.parent_key,
                            );
                            
                            if (count === 0) return null;

                            return (
                              <React.Fragment key={i}>
                                {Array.from({ length: count }).map((_, idx) =>
                                  subFields.map((subAttr, sIdx) => (
                                    <div key={`${idx}-${sIdx}`} className="form-group">
                                      <label>{`Member ${idx + 1} ${subAttr.label}`}</label>
                                      {subAttr.element_type === "dropdown" ? (
                                        <CustomSelect
                                          name={`${attr.attribute_key}.${idx}.${subAttr.attribute_key}`}
                                          control={control}
                                          options={subAttr.lov.map((o) => ({
                                            value: o.attribute_value,
                                            label: o.name,
                                          }))}
                                          value={
                                            subAttr.lov
                                              .map((o) => ({
                                                value: o.attribute_value,
                                                label: o.name,
                                              }))
                                              .find(
                                                (o) =>
                                                  o.value === arrayData[idx]?.[subAttr.attribute_key],
                                              ) || null
                                          }
                                          onChange={(opt) =>
                                            handleArrayChange(
                                              tab.entityid,
                                              attr.attribute_key,
                                              idx,
                                              subAttr.attribute_key,
                                              opt.value,
                                            )
                                          }
                                          usePortal={true}
                                        />
                                      ) : subAttr.element_type === "text" ? (
                                        <Input
                                          type="text"
                                          name={`${attr.attribute_key}.${idx}.${subAttr.attribute_key}`}
                                          control={control}
                                          placeholder="Enter"
                                          errors={errors}
                                          value={arrayData[idx]?.[subAttr.attribute_key] || ""}
                                          onChange={(e) =>
                                            handleArrayChange(
                                              tab.entityid,
                                              attr.attribute_key,
                                              idx,
                                              subAttr.attribute_key,
                                              e.target.value,
                                            )
                                          }
                                        />
                                      ) : subAttr.element_type === "date" ? (
                                        <DateField
                                          type="date"
                                          name={`${attr.attribute_key}.${idx}.${subAttr.attribute_key}`}
                                          control={control}
                                          errors={errors}
                                          value={arrayData[idx]?.[subAttr.attribute_key] || ""}
                                          onChange={(e) =>
                                            handleArrayChange(
                                              tab.entityid,
                                              attr.attribute_key,
                                              idx,
                                              subAttr.attribute_key,
                                              e.target.value,
                                            )
                                          }
                                          min={subAttr.min}
                                          max={subAttr.max}
                                        />
                                      ) : null}
                                    </div>
                                  ))
                                )}
                              </React.Fragment>
                            );
                          }

                          return (
                            <div
                              className={`form-group ${
                                storedValue &&
                                editingAttribute !==
                                  `${tab.entityid}-${attr.attribute_key}`
                                  ? "flex-container"
                                  : ""
                              }`}
                            >
                              <label>{attr.label}</label>
                              {
                                // storedValue &&
                                // // editingAttribute !==
                                //   `${tab.entityid}-${attr.attribute_key}` ? (
                                //   <div
                                //     className="stored-value"
                                //     onClick={() =>
                                //       !attr.is_disabled &&
                                //       handleEditClick(
                                //         tab.entityid,
                                //         // "product_attribute_list",
                                //         attr.attribute_key
                                //       )
                                //     }
                                //   >
                                //     {storedValue}
                                //   </div>
                                // ) :
                                attr.element_type === "dropdown" ||
                                attr.element_type === "range" ? (
                                  <CustomSelect
                                    key={attr.attribute_key}
                                    name={attr.attribute_key}
                                    control={control}
                                    options={attr.lov.map((option) => ({
                                      value: option.attribute_value,
                                      label: option.name,
                                    }))}
                                    errors={errors}
                                    defaultValue={
                                      attr.lov.find(
                                        (option) =>
                                          option.attribute_value ===
                                          storedRawValue,
                                      )?.attribute_value || ""
                                    }
                                    value={
                                      attr.lov
                                        .map((option) => ({
                                          value: option.attribute_value,
                                          label: option.name,
                                        }))
                                        .find(
                                          (option) =>
                                            option.value === storedRawValue,
                                        ) || null
                                    }
                                    onChange={(selectedOption) => {
                                      handleChange(
                                        tab.entityid,
                                        // "product_attribute_list",
                                        attr.attribute_key,
                                        selectedOption?.value,
                                      );
                                    }}
                                    usePortal={true}
                                  />
                                ) : attr.element_type === "number" ? (
                                  <Input
                                    key={attr.attribute_key}
                                    type="tel"
                                    name={attr.attribute_key}
                                    control={control}
                                    placeholder="Enter"
                                    // label={attr.label}
                                    errors={errors}
                                    rules={{
                                      required: attr.isRequired
                                        ? {
                                            value: true,
                                            message: "Required field",
                                          }
                                        : false,
                                      min: {
                                        value: attr.min,
                                        message: `Value must be at least ${attr.min}`,
                                      },
                                      max: {
                                        value: attr.max,
                                        message: `Value must be no more than ${attr.max}`,
                                      },
                                    }}
                                    minLength={attr?.minLength}
                                    maxLength={attr?.maxLength}
                                    // defaultValue={storedValue}
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^0-9]/g,
                                        "",
                                      ); // Remove non-numeric characters
                                    }}
                                    onBlur={(e) => {
                                      const value = e.target.value;
                                      handleChange(
                                        tab.entityid,
                                        // "product_attribute_list",
                                        attr.attribute_key,
                                        value,
                                      );
                                    }}
                                  />
                                ) : attr.element_type === "badge" ? (
                                  <Input
                                    key={attr.attribute_key}
                                    type="text"
                                    name={attr.attribute_key}
                                    control={control}
                                    placeholder="Enter"
                                    errors={errors}
                                    rules={{
                                      required: attr.isRequired
                                        ? {
                                            value: true,
                                            message: "Required field",
                                          }
                                        : false,
                                      min: {
                                        value: attr.min,
                                        message: `Value must be at least ${attr.min}`,
                                      },
                                      max: {
                                        value: attr.max,
                                        message: `Value must be no more than ${attr.max}`,
                                      },
                                    }}
                                    minLength={attr?.minLength}
                                    maxLength={attr?.maxLength}
                                    value={getValues(attr.attribute_key) || ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      handleChange(
                                        attr.entityid,
                                        // "product_attribute_list",
                                        attr.attribute_key,
                                        value,
                                      );
                                    }}
                                  />
                                ) : null
                              }
                            </div>
                          );
                        })}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
                </Accordion>
              </div>
            </div>
          )}
        </div>
      </Card>

      {productTabs?.some((tab) => tab.addons?.length > 0) && (
        <Card>
          <div className="filter--container">
            <div className="product-info-container">
              <div className="filter--accordion--header">
                <div className="widget--title">Add Ons</div>
                <h4 className="filter--button" onClick={handleShow}>
                  Edit
                </h4>
              </div>
              <div className="filter--accordion">
                <Accordion defaultActiveKey="0">
                  {productTabs
                    ?.filter((tab) => tab.addons.length > 0)
                    .map((tab, index) => (
                      <Accordion.Item key={index} eventKey={index.toString()}>
                        <Accordion.Header>{tab.name}</Accordion.Header>
                        <Accordion.Body>
                          {/* {tab?.addons?.map((addon, j) => {
                        const storedValue =
                          attributeForm[tab.entityid]?.[addon.name];

                        return (
                          <div
                            key={j}
                            className={`form-group ${
                              storedValue &&
                              editingAttribute !==
                                `${tab.entityid}-${addon.name}`
                                ? "flex-container"
                                : ""
                            }`}
                          >
                            <label>{addon.label}</label>

                            {storedValue &&
                            editingAttribute !==
                              `${tab.entityid}-${addon.name}` ? (
                              <div
                                className="stored-value"
                                onClick={() =>
                                  handleEditClick(
                                    tab.entityid,
                                    // "product_addon_list",
                                    addon.name
                                  )
                                }
                              >
                                {storedValue}
                              </div>
                            ) : addon.element_type === "checkbox" ? (
                              <Checkbox
                                name={addon.name}
                                control={control}
                                options={[addon]}
                                errors={errors}
                                onInputChange={(name, checked) => {
                                  // Correct parameter names
                                  console.log(
                                    "Checkbox clicked:",
                                    name,
                                    checked
                                  );
                                  const value = checked ? "yes" : "no";
                                  handleChange(tab.entityid, name, value);
                                }}
                              />
                            ) : (
                              <Input
                                type="number"
                                name={addon.name}
                                control={control}
                                placeholder={`Enter ${addon.label}`}
                                errors={errors}
                                rules={{
                                  required: "This field is required",
                                  min: {
                                    value: addon.min || 0,
                                    message: `Value must be at least ${
                                      addon.min || 0
                                    }`,
                                  },
                                  max: {
                                    value: addon.max || 100,
                                    message: `Value must be no more than ${
                                      addon.max || 100
                                    }`,
                                  },
                                }}
                                defaultValue={storedValue}
                                onBlur={(e) => {
                                  const value = e.target.value;
                                  handleChange(
                                    tab.entityid,
                                    // "product_addon_list",
                                    addon.name,
                                    value
                                  );
                                }}
                              />
                            )}
                          </div>
                        );
                      })} */}

                          {tab?.addons?.map((addon, j) => {
                            const storedValue =
                              attributeForm[tab.entityid]?.[addon.name];
                            if (addon.element_type === "checkbox") {
                              const checkboxValue =
                                storedValue === "yes" ? "yes" : "no";
                              setValue(addon.name, checkboxValue);
                            }

                            return (
                              <div key={j} className="form-group">
                                <label>{addon.label}</label>

                                {addon.element_type === "checkbox" ? (
                                  <Checkbox
                                    key={addon.name}
                                    name={addon.name}
                                    control={control}
                                    options={[addon]}
                                    checked={storedValue === "yes"}
                                    errors={errors}
                                    hideLabel={true}
                                    onInputChange={(name, checked) => {
                                      const value = checked ? "yes" : "no";
                                      handleChange(tab.entityid, name, value);
                                    }}
                                  />
                                ) : (
                                  <Input
                                    key={addon.name}
                                    type="tel"
                                    name={addon.name}
                                    control={control}
                                    placeholder="Enter"
                                    errors={errors}
                                    rules={{
                                      required: addon.isRequired
                                        ? {
                                            value: true,
                                            message: "Required field",
                                          }
                                        : false,
                                      min: {
                                        value: addon.min,
                                        message: `Value must be at least ${addon.min}`,
                                      },
                                      max: {
                                        value: addon.max,
                                        message: `Value must be no more than ${addon.max}`,
                                      },
                                    }}
                                    minLength={addon?.minLength}
                                    maxLength={addon?.maxLength}
                                    onInput={(e) => {
                                      e.target.value = e.target.value.replace(
                                        /[^0-9]/g,
                                        "",
                                      ); // Remove non-numeric characters
                                    }}
                                    onBlur={(e) => {
                                      handleChange(
                                        tab.entityid,
                                        addon.name,
                                        e.target.value,
                                      );
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                </Accordion>
              </div>
            </div>
          </div>
        </Card>
      )}

      <ProductModal show={show} handleClose={handleClose} />
    </>
  );
};

export default Filter1;
